import { useEffect, type RefObject } from 'react';

export const useClosedOutside = (
  root: RefObject<HTMLElement | null>,
  open: boolean,
  close: () => void,
  companion?: RefObject<HTMLElement | null>,
): void => {
  useEffect(() => {
    if (!open) return undefined;
    const closeOutside = (event: PointerEvent) => {
      const target = event.target;
      if (!(target instanceof Node)) return;
      if (root.current?.contains(target) === true || companion?.current?.contains(target) === true) return;
      close();
    };
    document.addEventListener('pointerdown', closeOutside);
    return () => {
      document.removeEventListener('pointerdown', closeOutside);
    };
  }, [root, open, close, companion]);
};
